import { Box, Typography } from '@mui/material';
import React from 'react';

export default function FieldEntry({ title, value, show = true }) {
  if (!show || value === null || value === undefined) return null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'baseline', py: 0.25, fontSize: '0.8rem' }}>
      <Typography
        variant="body2"
        sx={{
          flex: '0 0 50%',
          textAlign: 'right',
          pr: 1,
          fontWeight: 600,
          color: 'text.secondary',
          fontSize: 'inherit',
        }}
      >
        {title}
      </Typography>
      <Typography variant="body2" sx={{ flex: '0 0 50%', pl: 1, fontSize: 'inherit' }}>
        {value}
      </Typography>
    </Box>
  );
}
